window.addEventListener("hoContentLoaded", () => {
	Vue.component('reveal', {
		data: function () {
			return {
				active:false
			}
		},
		props: {
			margin: {
				type: Number,
				default: 0
			},
			mobileMargin: {
				type: Number,
				default: 0
			}
		},
		methods: {
			toggle()
			{
				const pattern = this.$el.closest("[data-pattern]");

				if(!this.active)
				{
					if(pattern)
					{
						pattern.classList.add("pattern-content-reveal-open");
					}

					this.active = true;
				}
				else
				{
					if(pattern)
						pattern.classList.remove("pattern-content-reveal-open");

					const controls = this.$el.querySelector(".content-reveal-controls");
					let offset = 0;

					if(controls)
						offset = controls.getBoundingClientRect().height;

					let m = 0;
					if(window.innerWidth < 768)
						m = this.mobileMargin;
					else
						m = this.margin;

					console.log(offset+m);
					window.providerScroll.scrollTo(this.$el,offset+m);
					this.active = false;
				}
			}
		}
	});
});
